export default (function () {
  var $text = $('.help-section .block-title .title');
  $text.html(function (index, text) {
    return text.replace(new RegExp("help", 'g'), "<span class='title__underline'>help</span>");
  });
  var $text2 = $('.good-kind .block-title .title');
  $text2.html(function (index, text2) {
    return text2.replace(new RegExp("good", 'g'), "<span class='title__underline'>good</span>");
  });
  $('.button').click(function () {
    jQuery(document).bind('gform_post_render', function () {
      var $cont = $('form .ginput_container');
      $cont.each(function (i, el) {
        var $sib = $(el).siblings('.gfield_validation_message');
        var $inputs = $(el).find('input, textarea');
        $(this).append($sib);
        $inputs.change(function () {
          if ($(this).val() == '' || $(this).val() == ' ' || $(this).val() == null || $(this).val() == undefined) {
            $(this).closest('.gfield').addClass('gfield_error');
          } else {
            $(this).closest('.gfield_error').removeClass('gfield_error');
          }
        });
        $sib.click(function () {
          $(this).addClass('active');
        });
      }); // let $formInput = $('#gform_1 .ginput_container').children();
      // console.log('test');
      // $formInput.each(function (i, el) {
      //     if (!$(el).val()) {
      //         $(el).attr('value', '');
      //         if ($(el).val() !== '' && $(el).attr('value') == Number()  ) {
      //             console.log('333')
      //             $(el).addClass('active');
      //             $(el).attr("placeholder", "This field is required");
      //         } else {
      //             console.log('777')
      //         }
      //         // e.prevent
      //     } else {
      //         $(el).removeClass('active');
      //     }
      //
      //
      //     // var name = $(el).attr('name');
      //     // deleteData[name] = val;
      // })
    });
  });
});